<template>
    <div class="a-count">{{ data }}</div>
</template>

<script>
export default {
    name: 'ACount',
    props: {
        data: {
            type: Number,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.a-count {
    background-color: var(--color-primary);
    color: var(--color-white);
    font-size: var(--font-size-tiny);
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;

    &.--dark {
        background-color: var(--color-dark);
    }
}
</style>
